export default __webpack_public_path__ + "static/media/specialTrainList.b6523a34.webp";